// extracted by mini-css-extract-plugin
export var animLoader = "HelpCenter-module--animLoader--5474f";
export var back = "HelpCenter-module--back--9fee2";
export var backIcon = "HelpCenter-module--backIcon--7514e";
export var badge = "HelpCenter-module--badge--1dfed";
export var content = "HelpCenter-module--content--9e52c";
export var downloadIcon = "HelpCenter-module--downloadIcon--6bbf1";
export var downloadLoading = "HelpCenter-module--downloadLoading--bc85d";
export var footer = "HelpCenter-module--footer--13213";
export var formContent = "HelpCenter-module--formContent--767df";
export var formFooter = "HelpCenter-module--formFooter--efa16";
export var greenLink = "HelpCenter-module--greenLink--a11cd";
export var header = "HelpCenter-module--header--3c5f6";
export var helpCenter = "HelpCenter-module--helpCenter--8ebb4";
export var icon = "HelpCenter-module--icon--b60c4";
export var liveChat = "HelpCenter-module--liveChat--49bf9";
export var loader = "HelpCenter-module--loader--c7f6b";
export var openInNewIcon = "HelpCenter-module--openInNewIcon--59715";
export var result = "HelpCenter-module--result--5574d";
export var results = "HelpCenter-module--results--a829a";
export var resultsTitle = "HelpCenter-module--resultsTitle--0a7d0";
export var search = "HelpCenter-module--search--6c6cf";
export var searchInput = "HelpCenter-module--searchInput--71bcf";
export var title = "HelpCenter-module--title--3aff8";
export var titleLeft = "HelpCenter-module--titleLeft--2ccce";
export var titleRight = "HelpCenter-module--titleRight--2c4ff";
export var titleText = "HelpCenter-module--titleText--6809e";
export var unreadMessages = "HelpCenter-module--unreadMessages--1dd9a";
export var uploadDocuments = "HelpCenter-module--uploadDocuments--79f8e";
export var visible = "HelpCenter-module--visible--b67d5";